<template>
  <div class="renovation">
    <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:100%">

      <el-form label-width="150px">
        <el-form-item label="图片显示比例">
          <el-radio v-model="confige.setting_value.ratio" label="1">4:2</el-radio>
          <el-radio v-model="confige.setting_value.ratio" label="2">2:4</el-radio>
        </el-form-item>

        <el-form-item :style="confige.setting_value.ratio === '1' ? 'height:250px' : 'height:450px'" label="轮播图预览">
          <div :class="confige.setting_value.ratio === '1' ? 'lunbo-fore-three' : 'lunbo-three-fore'"
            v-if="banner.length > 0">
            <el-carousel indicator-position="outside" :height="confige.setting_value.ratio === '1' ? '200px' : '400px'">
              <div v-for="(item, index) in banner" :key="index" >
                <el-carousel-item v-if="item && item.url">
                  <img v-if="item.url" :src="item.url" style="width: 100%; height: 100%;">
                </el-carousel-item>
              </div>

            </el-carousel>
          </div>
          <div :class="confige.setting_value.ratio === '1' ? 'lunbo-fore-three' : 'lunbo-three-fore'" v-else>
            <el-empty description="请上传图片"></el-empty>
          </div>

        </el-form-item>
        <el-form-item label="上传图片">
          <div class="primary-flex">
            <dyhUpload ref="dyhUploadRef" @dyhUploadReturn="dyhUploadReturn" :count="5"></dyhUpload>
          </div>
        </el-form-item>
        <el-form-item label="页面广播">
          <div class="primary-flex">
            <el-input style="width: 650px;" :autosize="{ minRows: 2, maxRows: 6 }" show-word-limit maxlength="500"
              v-model="confige.setting_value.notice" type="textarea" placeholder="请输入主页广播内容"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="">
          <div class="primary-flex">
            <el-button type="primary" @click="submit">保存提交</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-scrollbar>
  </div>
</template>
<script>
/* eslint-disable */
import { settingsConfigure, getConfigure } from "@/api/onlines/shop.js";
import { getThumbnailImage,getBaseImage } from '@/api/basic.js';
import dyhUpload from '@/components/dyhUpload.vue';
export default {
  components: {
    dyhUpload
  },
  data() {
    return {
      banner: [],
      confige: {
        setting_id: "00001",
        setting_name: "主页轮播图",
        setting_value: {
          banner: [],
          notice: "",
          ratio: "1"

        },
        remark: ""
      }
    };
  },
  mounted() {
    console.log("express");
    this.getConfigure();
  },
  methods: {
    getConfigure() {
      getConfigure(this.confige.setting_id).then(res => {
        const configure = res.find(item => item.setting_id === "00001");
        if (configure) {
          this.confige.setting_value = JSON.parse(configure.setting_value);
          if (this.confige.setting_value.banner && this.confige.setting_value.banner.length > 0) {
            this.banner = this.confige.setting_value.banner.map(item => {
              if (item.url) {
                return item;
              } else if (item.media_no) {
                return {
                  media_no: item.media_no,
                  url: getBaseImage(item.media_no)
                }
              } else {
                return null;
              }
            }).filter(item => item !== null);
            this.$refs.dyhUploadRef.setBaseImage(this.banner.map(item => { return item.url }));
            console.log("轮播图数据", this.banner);
          }
          console.log("获取配置结果", this.confige);
        }
      })
    },
    submit() {
      let list = [];
      for (let i = 0; i < this.banner.length; i++) {
        if (this.banner[i] && ((this.banner[i].media_no && this.banner[i].media_no.length > 0) || (this.banner[i].url && this.banner[i].url.length > 0))) {
          list.push({
            media_no: this.banner[i].media_no,
            alt: "",
            sort: ""
          });
        }
      }
      settingsConfigure(
        {
          ...this.confige,
          setting_value: JSON.stringify({
            banner: list,
            notice: this.confige.setting_value.notice,
            ratio: this.confige.setting_value.ratio
          })
        }
      ).then(res => {
        console.log("提交结果", res);
        this.$message.success("提交成功");
      })
      console.log("提交的轮播图数据", this.banner);
      console.log("提交的轮播图数据", list);
      /*  orderMerchantListSaleReport(this.confige).then(res => {
  console.log("提交结果", res);
       }) */
      /*  this.$message.success("提交成功"); */
      /* this.$message.success("提交成功");
      this.$refs.dyhUploadRef.clear();
      this.banner = []; */
    },
    dyhUploadReturn(v) {
      this.banner = [];
      for (let i = 0; i < v.imageList.length; i++) {
        if (v.imageList[i] && ((v.imageList[i].media_no && v.imageList[i].media_no.length > 0) || (v.imageList[i].url && v.imageList[i].url.length > 0))) {
          this.banner.push(v.imageList[i]);
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
.renovation {
  width: 100%;
  height: auto;
  min-height: 100%;
  background-color: #fff;
  padding: 20px;
}

.lunbo-fore-three {
  width: 400px;
  height: 200px;
  margin-bottom: 40px;
}

.lunbo-three-fore {
  width: 400px;
  height: 200px;
  margin-bottom: 40px;
}
</style>